__turbopack_context__.v({
  "container": "ErrorMessage-module__qc8SfG__container",
  "onDarkBackground": "ErrorMessage-module__qc8SfG__onDarkBackground",
});
